"use client"

import { signIn } from "../actions.ts"
import { useAuthForm } from "../_components/AuthForm.tsx"
import { LoginFormView } from "./LoginFormView.tsx"

export function LoginForm({
  redirectTo,
  erro = null,
}: {
  redirectTo: string
  erro?: string | null
}) {
  const { state, formAction, banner } = useAuthForm(signIn)

  return (
    <LoginFormView
      redirectTo={redirectTo}
      formAction={formAction}
      pending={state.pending}
      banner={banner}
      erro={erro}
      fieldError={state.fieldError}
    />
  )
}
